import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "pantry-ingredient-food-view" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "pantry-ingredient-food-view-empty" }, null, -1)
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectingIngredientList = _resolveComponent("SelectingIngredientList")
  const _component_PantryIngredientEmptyView = _resolveComponent("PantryIngredientEmptyView")

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.isEmpty())
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getData(), (item, index) => {
            return (_openBlock(), _createBlock(_component_SelectingIngredientList, {
              key: index,
              categoryTitle: item.title,
              ingredientList: item.list,
              onOnSelect: _ctx.onSelectIngredient
            }, null, 8, ["categoryTitle", "ingredientList", "onOnSelect"]))
          }), 128 /* KEYED_FRAGMENT */)),
          _hoisted_3
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_PantryIngredientEmptyView)
        ]))
  ], 512)), [
    [_vShow, _ctx.isShow()]
  ])
}